import CitizenHistoryActions from "../../../web/sos/citizen-history/utils/citizen-history-actions.js";

export default function ReportContent({history}) {
    return (
        <table className="table report-table">
            <thead className="thead-background">
                <tr className="bg-[#f6f6f6] text-left">
                    <th className="w-[10%]">Data/Hora</th>
                    <th className="w-[15%]">Cidadão</th>
                    <th className="w-[15%]">Ação</th>
                    <th className="w-[15%]">Usuário</th>
                    <th className="w-[35%]">Descrição</th>
                </tr>
            </thead>
            <tbody className="bg-white">
                {history.map((item, index) => (
                    <tr key={item.id ?? index} className="table-break-word">
                        <td className="w-[10%]">{item.dtAction ?? ""}</td>
                        <td className="w-[15%]">{item.target ?? ""}</td>
                        <td className="w-[15%]">{CitizenHistoryActions.toView(item.action)}</td>
                        <td className="w-[15%]">{item.username ?? ""}</td>
                        <td className="w-[35%] wrap-break-word whitespace-pre-wrap">{item.description ?? ""}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
